module.exports = __webpack_public_path__ + "static/media/nft-games-icon1.f402da8a.svg";